// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"1480dd1fc654ae944e5b","762":"8b71bf4a10ec198dd603","883":"7dc2cec07b631e7847f5"}[chunkId] + ".js";
};